"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = exports.DEFAULT_IMAGE = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_sanofi/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_sanofi/cssConstants.js"));

var _ERGOComponents = _interopRequireDefault(require("./ERGOComponents.scss"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _core = require("@material-ui/core");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _UserManagementService = _interopRequireDefault(require("../../Equizzer/services/UserManagementService"));

var _DateTimeHelper = require("../../../../helpers/DateTimeHelper");

var _Image = _interopRequireDefault(require("../../Image/Image"));

var _Cancel = _interopRequireDefault(require("@material-ui/icons/Cancel"));

var _ErgoStrings = require("./ErgoStrings");

var _CordovaHelper = require("../../../../helpers/CordovaHelper");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _ResumeSuspendListeners = require("../../../../helpers/ResumeSuspendListeners");

var _targetCss$colors, _targetCss$colors2, _targetCss$colors3, _targetCss$colors4, _targetCss$colors5, _targetCss$colors6;

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var StyledTextField = (0, _core.withStyles)({
  root: {
    padding: '10px 0',
    '& label.Mui-focused': {
      color: _cssConstants["default"].colors.buttonBackground
    },
    '& .MuiFormLabel-root': {
      maxWidth: 'calc(100% - 28px)'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: _cssConstants["default"].colors.buttonBackground
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: _cssConstants["default"].colors.buttonBackground
      },
      '&.Mui-focused fieldset': {
        borderColor: _cssConstants["default"].colors.buttonBackground
      }
    }
  }
})(_core.TextField);
var StyledRadio = (0, _core.withStyles)({
  root: {
    '&$checked': {
      color: "".concat((_targetCss$colors = _cssConstants["default"].colors) === null || _targetCss$colors === void 0 ? void 0 : _targetCss$colors.buttonBackground, " !important")
    },
    color: (_targetCss$colors2 = _cssConstants["default"].colors) === null || _targetCss$colors2 === void 0 ? void 0 : _targetCss$colors2.buttonBackground
  }
})(_core.Radio);
var StyledButton = (0, _core.withStyles)({
  root: {
    backgroundColor: (_targetCss$colors3 = _cssConstants["default"].colors) === null || _targetCss$colors3 === void 0 ? void 0 : _targetCss$colors3.buttonBackground,
    color: (_targetCss$colors4 = _cssConstants["default"].colors) === null || _targetCss$colors4 === void 0 ? void 0 : _targetCss$colors4.buttonCaption,
    '&:hover': {
      backgroundColor: (_targetCss$colors5 = _cssConstants["default"].colors) === null || _targetCss$colors5 === void 0 ? void 0 : _targetCss$colors5.buttonBackgroundHover,
      color: (_targetCss$colors6 = _cssConstants["default"].colors) === null || _targetCss$colors6 === void 0 ? void 0 : _targetCss$colors6.buttonCaption
    }
  }
})(_Button["default"]);
var DEFAULT_IMAGE = 'data:image/jpeg;base64,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';
exports.DEFAULT_IMAGE = DEFAULT_IMAGE;

var ErgoCandidateView = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ErgoCandidateView, _React$Component);

  var _super = _createSuper(ErgoCandidateView);

  function ErgoCandidateView(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ErgoCandidateView);
    _this = _super.call(this, props);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "updateCandidateInfoState", function (obj) {
      return _this.setState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          candidateInfos: _objectSpread(_objectSpread({}, prev.candidateInfos), obj)
        });
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setSalutation", function (evt) {
      return _this.updateCandidateInfoState({
        salutation: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setFamilySituation", function (evt) {
      return _this.updateCandidateInfoState({
        familysituation: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setBranche", function (evt) {
      return _this.updateCandidateInfoState({
        branche: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setFirstName", function (evt) {
      return _this.updateCandidateInfoState({
        firstname: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setLastName", function (evt) {
      return _this.updateCandidateInfoState({
        lastname: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setZipcode", function (evt) {
      return _this.updateCandidateInfoState({
        zipcode: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setCity", function (evt) {
      return _this.updateCandidateInfoState({
        city: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setStreet", function (evt) {
      return _this.updateCandidateInfoState({
        street: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setPhoneNumber", function (evt) {
      return _this.updateCandidateInfoState({
        phone: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setComment", function (evt) {
      return _this.updateCandidateInfoState({
        comment: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setEmail", function (evt) {
      return _this.updateCandidateInfoState({
        email: evt.target.value
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "saveUserData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var _this$props$triggerCa, _this$props;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _UserManagementService["default"].updateCandidate(_this.state.candidateInfos);

            case 2:
              _this.setState({
                editMode: false
              });

              (_this$props$triggerCa = (_this$props = _this.props).triggerCandidateReload) === null || _this$props$triggerCa === void 0 ? void 0 : _this$props$triggerCa.call(_this$props);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "createCandidate", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var infos, el, _this$props$onCreated, _this$props2, _candidate$string_id, candidate, _el;

      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.setState({
                errorMessage: null
              });

              infos = _this.state.candidateInfos;
              if (_this.props.candidateType) infos.candidate_type = _this.props.candidateType;

              if (!(!infos.email || !infos.firstname || !infos.lastname)) {
                _context2.next = 8;
                break;
              }

              _this.setState({
                errorMessage: 'Bitte geben Sie mindestens eine E-Mailadresse, einen Vor- und einen Nachnamen ein.'
              });

              el = document.getElementById('container');
              if (el) el.parentElement.scrollTop = 0;
              return _context2.abrupt("return");

            case 8:
              _context2.prev = 8;
              _context2.next = 11;
              return _UserManagementService["default"].postCandidate(infos);

            case 11:
              candidate = _context2.sent;
              console.log('candidate created', candidate);
              (_this$props$onCreated = (_this$props2 = _this.props).onCreatedFn) === null || _this$props$onCreated === void 0 ? void 0 : _this$props$onCreated.call(_this$props2, (_candidate$string_id = candidate.string_id) !== null && _candidate$string_id !== void 0 ? _candidate$string_id : candidate.id);
              _context2.next = 21;
              break;

            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](8);

              if (_context2.t0.message.indexOf('lastname does not match constraint') !== -1) {
                _this.setState({
                  errorMessage: 'Bitte geben Sie einen korrekten Nachnamen ein.'
                });
              } else if (_context2.t0.message.indexOf('firstname does not match constraint') !== -1) {
                _this.setState({
                  errorMessage: 'Bitte geben Sie einen korrekten Vornamen ein.'
                });
              } else if (_context2.t0.message.indexOf('email does not match constraint') !== -1) {
                _this.setState({
                  errorMessage: 'Bitte geben Sie eine korrekte E-Mailadresse ein.'
                });
              } else if (_context2.t0.message.toLowerCase().indexOf('duplicate email') !== -1) {
                _this.setState({
                  errorMessage: 'Es gibt bereits einen Interessenten mit dieser E-Mailadresse.'
                });
              } else {
                _this.setState({
                  errorMessage: _context2.t0.message
                });
              }

              _el = document.getElementById('container');
              if (_el) _el.parentElement.scrollTop = 0;

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[8, 16]]);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "changeProfilePic", function () {
      var galleryButton = {
        label: (0, _ErgoStrings.getString)('CAND_FROM_GALLERY'),
        callback: function () {
          var _callback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
            var picture, imgSrc, candidateInfos;
            return _regenerator["default"].wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _CordovaHelper.takePictureFromGallery)(500, 500);

                  case 3:
                    picture = _context3.sent;

                    if (picture) {
                      imgSrc = "data:image/jpg;base64,".concat(picture);
                      candidateInfos = _this.state.candidateInfos;
                      candidateInfos.picture = imgSrc;

                      _this.setState({
                        candidateInfos: candidateInfos
                      });
                    }

                    _context3.next = 10;
                    break;

                  case 7:
                    _context3.prev = 7;
                    _context3.t0 = _context3["catch"](0);
                    console.log('Error taking Picture from gallery in ErgoCandidateview.js', _context3.t0);

                  case 10:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[0, 7]]);
          }));

          function callback() {
            return _callback.apply(this, arguments);
          }

          return callback;
        }()
      };
      var cameraButton = {
        label: (0, _ErgoStrings.getString)('CAND_FROM_CAMERA'),
        callback: function () {
          var _callback2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
            var picture, imgSrc, candidateInfos;
            return _regenerator["default"].wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _CordovaHelper.takePictureWithCamera)(500, 500);

                  case 3:
                    picture = _context4.sent;

                    if (picture) {
                      imgSrc = "data:image/jpg;base64,".concat(picture);
                      candidateInfos = _this.state.candidateInfos;
                      candidateInfos.picture = imgSrc;

                      _this.setState({
                        candidateInfos: candidateInfos
                      });
                    }

                    _context4.next = 10;
                    break;

                  case 7:
                    _context4.prev = 7;
                    _context4.t0 = _context4["catch"](0);
                    console.log('Error taking Picture with Camera in ErgoCandidateview.js', _context4.t0);

                  case 10:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, null, [[0, 7]]);
          }));

          function callback() {
            return _callback2.apply(this, arguments);
          }

          return callback;
        }()
      };
      (0, _MuiAlertHelper.showAlertWithOptions)({
        html: _this.props.isSingleUser ? (0, _ErgoStrings.getString)('CAND_USER_CHOOSE_IMAGE_SOURCE_TEXT') : (0, _ErgoStrings.getString)('CAND_OTHER_CHOOSE_IMAGE_SOURCE_TEXT'),
        title: _this.props.isSingleUser ? (0, _ErgoStrings.getString)('CAND_USER_CHOOSE_IMAGE_SOURCE_TITLE') : (0, _ErgoStrings.getString)('CAND_OTHER_CHOOSE_IMAGE_SOURCE_TITLE'),
        centeredContent: true,
        buttons: [cameraButton, galleryButton]
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "editUser", function () {
      return _this.setState({
        editMode: true
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "cancelEdit", function () {
      return _this.setState({
        editMode: false,
        candidateInfos: JSON.parse((0, _stringify["default"])(_this.props.infos))
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "deleteApplication", function () {
      var okButton = {
        label: (0, _ErgoStrings.getString)('YES'),
        callback: function () {
          var _callback3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
            var result;
            return _regenerator["default"].wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return _UserManagementService["default"].removeCandidate(_this.state.candidateInfos);

                  case 2:
                    result = _context5.sent;
                    console.log('remove candidate result');

                    if (result.success) {
                      (0, _MuiAlertHelper.showAlertWithOptions)({
                        title: 'Bewerbung zurückgezogen',
                        message: 'Ihre Bewerbung wurde zurückgezogen. Ihre Daten werden automatisch gelöscht.',
                        showCloseButton: false,
                        buttons: [{
                          label: (0, _ErgoStrings.getString)('OK'),
                          callback: function callback() {
                            /*logOut(true, null, false)*/
                          }
                        }]
                      });
                    }

                  case 5:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));

          function callback() {
            return _callback3.apply(this, arguments);
          }

          return callback;
        }()
      };
      var cancelButton = {
        label: (0, _ErgoStrings.getString)('CANCEL'),
        callback: function callback() {}
      };
      (0, _MuiAlertHelper.showAlertWithOptions)({
        title: 'Bewerbung zurückziehen?',
        message: 'Wollen Sie Ihre Bewerbung zurückziehen?',
        buttons: [cancelButton, okButton]
      });
    });
    _this.state = {
      candidateInfos: null,
      editMode: false,
      errorMessage: null
    };
    return _this;
  }

  (0, _createClass2["default"])(ErgoCandidateView, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$infos, _this$state$candidate;

      if (this.props.pageIndex === 1 && prevProps.pageIndex === 0 && this.props.infos) this.setState({
        candidateInfos: JSON.parse((0, _stringify["default"])(this.props.infos))
      });
      if (((_this$props$infos = this.props.infos) === null || _this$props$infos === void 0 ? void 0 : _this$props$infos.last_updated) !== ((_this$state$candidate = this.state.candidateInfos) === null || _this$state$candidate === void 0 ? void 0 : _this$state$candidate.last_updated)) this.setState({
        candidateInfos: JSON.parse((0, _stringify["default"])(this.props.infos))
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.forceEditMode) this.setState({
        candidateInfos: {}
      });
      (0, _ResumeSuspendListeners.addOnResumeListener)(function () {
        var _this2$props$triggerC, _this2$props;

        return (_this2$props$triggerC = (_this2$props = _this2.props).triggerCandidateReload) === null || _this2$props$triggerC === void 0 ? void 0 : _this2$props$triggerC.call(_this2$props);
      });
      document.addEventListener('updateCandidates', function () {
        var _this2$props$triggerC2, _this2$props2;

        return (_this2$props$triggerC2 = (_this2$props2 = _this2.props).triggerCandidateReload) === null || _this2$props$triggerC2 === void 0 ? void 0 : _this2$props$triggerC2.call(_this2$props2);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      (0, _ResumeSuspendListeners.removeOnResumeListener)(function () {
        var _this3$props$triggerC, _this3$props;

        return (_this3$props$triggerC = (_this3$props = _this3.props).triggerCandidateReload) === null || _this3$props$triggerC === void 0 ? void 0 : _this3$props$triggerC.call(_this3$props);
      });
      document.removeEventListener('updateCandidates', function () {
        var _this3$props$triggerC2, _this3$props2;

        return (_this3$props$triggerC2 = (_this3$props2 = _this3.props).triggerCandidateReload) === null || _this3$props$triggerC2 === void 0 ? void 0 : _this3$props$triggerC2.call(_this3$props2);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$candidate2, _this$state$candidate3, _this$state$candidate4, _this$state$candidate5, _this$state$candidate6, _this$state$candidate7, _this$state$candidate8, _this$state$candidate9, _this$state$candidate10, _this$state$candidate11, _this$state$candidate12, _this$state$candidate13, _this$state$candidate14, _this$state$candidate15, _this$state$candidate16, _this$state$candidate17, _this$state$candidate18, _this$state$candidate19, _this$state$candidate20, _this$state$candidate21, _this$state$candidate22, _this$state$candidate23, _this$state$candidate24;

      if (!this.state.candidateInfos) return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      var createdDateToShow = !this.props.forceEditMode && (0, _DateTimeHelper.formatDateAndTime)(new Date(this.state.candidateInfos.date_created)) || undefined;
      var updatedDateToShow = !this.props.forceEditMode && (0, _DateTimeHelper.formatDateAndTime)(new Date(this.state.candidateInfos.last_updated)) || undefined;
      var progress = !this.props.forceEditMode && (((_this$state$candidate2 = this.state.candidateInfos) === null || _this$state$candidate2 === void 0 ? void 0 : (_this$state$candidate3 = _this$state$candidate2._history) === null || _this$state$candidate3 === void 0 ? void 0 : _this$state$candidate3.step) || 1) / (((_this$state$candidate4 = this.state.candidateInfos) === null || _this$state$candidate4 === void 0 ? void 0 : (_this$state$candidate5 = _this$state$candidate4._history) === null || _this$state$candidate5 === void 0 ? void 0 : _this$state$candidate5.maxStep) || 5) * 100 || undefined;
      console.log('candidateType', this.props.candidateType, _config["default"].askForDetailedRecruitingInfos, this.props.candidateType && this.props.candidateType !== 'apprentice');
      return /*#__PURE__*/_react["default"].createElement("div", {
        id: "container",
        style: {
          width: '90%',
          padding: '10px 0',
          margin: '0 5%'
        }
      }, !this.state.editMode && !this.props.forceEditMode && /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: _ERGOComponents["default"].card
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].header
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].pictureContainer,
        onClick: this.editUser
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "candidate image",
        className: _ERGOComponents["default"].picture,
        src: this.state.candidateInfos.picture || DEFAULT_IMAGE
      })), this.props.info && /*#__PURE__*/_react["default"].createElement("div", null, this.props.info), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].name,
        onClick: this.editUser
      }, "".concat(this.state.candidateInfos.firstname, " ").concat(this.state.candidateInfos.lastname)), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].created
      }, "Registriert am ".concat(createdDateToShow.dateString, " - ").concat(createdDateToShow.timeString))), this.state.candidateInfos._state && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].progressContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].title
      }, "Bewerbungsstatus"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].progressStatus,
        style: {
          color: this.state.candidateInfos._state.rgb
        }
      }, this.state.candidateInfos._state.app_text), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].progressBar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].progress,
        style: {
          backgroundColor: this.state.candidateInfos._state.rgb,
          width: "".concat(progress, "%")
        }
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].informationContainer
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].title
      }, "Informationen"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].infoText,
        onClick: this.editUser
      }, "E-Mail"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].text
      }, this.state.candidateInfos.email), /*#__PURE__*/_react["default"].createElement("hr", {
        className: _ERGOComponents["default"].divider
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].infoText,
        onClick: this.editUser
      }, "Telefonnummer"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].text
      }, this.state.candidateInfos.phone), /*#__PURE__*/_react["default"].createElement("hr", {
        className: _ERGOComponents["default"].divider
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].infoText,
        onClick: this.editUser
      }, "Postleitzahl"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].text
      }, this.state.candidateInfos.zipcode), /*#__PURE__*/_react["default"].createElement("hr", {
        className: _ERGOComponents["default"].divider
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].infoText,
        onClick: this.editUser
      }, "Stadt"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].text
      }, this.state.candidateInfos.city), /*#__PURE__*/_react["default"].createElement("hr", {
        className: _ERGOComponents["default"].divider
      }), !this.props.isSingleUser && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].infoText,
        onClick: this.editUser
      }, "Kommentar"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].text
      }, ((_this$state$candidate6 = this.state.candidateInfos) === null || _this$state$candidate6 === void 0 ? void 0 : _this$state$candidate6.comment) ? (_this$state$candidate7 = this.state.candidateInfos) === null || _this$state$candidate7 === void 0 ? void 0 : _this$state$candidate7.comment : '-'))), this.props.isSingleUser && /*#__PURE__*/_react["default"].createElement(StyledButton, {
        className: _ERGOComponents["default"].deleteButton,
        onClick: this.deleteApplication
      }, "Bewerbung zur\xFCckziehen")), (this.state.editMode || this.props.forceEditMode) && /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: _ERGOComponents["default"].card,
        style: {
          paddingTop: '20px'
        }
      }, !this.props.forceEditMode && /*#__PURE__*/_react["default"].createElement("div", {
        onClick: this.cancelEdit,
        className: _ERGOComponents["default"].editIconContainer
      }, /*#__PURE__*/_react["default"].createElement(_Cancel["default"], {
        className: _ERGOComponents["default"].editIcon
      })), this.state.errorMessage && /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].errorMessage
      }, this.state.errorMessage), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].picPreview
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].picPreviewContainer
      }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: "candidate image",
        className: _ERGOComponents["default"].previewPic,
        src: ((_this$state$candidate8 = this.state.candidateInfos) === null || _this$state$candidate8 === void 0 ? void 0 : _this$state$candidate8.picture) ? this.state.candidateInfos.picture : DEFAULT_IMAGE
      })), /*#__PURE__*/_react["default"].createElement(StyledButton, {
        className: _ERGOComponents["default"].picButton,
        onClick: this.changeProfilePic
      }, "Foto \xE4ndern")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].formTitle
      }, "Anrede"), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Herr',
        id: 'salutation',
        value: 'Herr',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate9 = this.state.candidateInfos) === null || _this$state$candidate9 === void 0 ? void 0 : _this$state$candidate9.salutation) === 'Herr',
        onChange: this.setSalutation
      }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Frau',
        id: 'salutation',
        value: 'Frau',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate10 = this.state.candidateInfos) === null || _this$state$candidate10 === void 0 ? void 0 : _this$state$candidate10.salutation) === 'Frau',
        onChange: this.setSalutation
      }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Divers',
        id: 'salutation',
        value: 'Divers',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate11 = this.state.candidateInfos) === null || _this$state$candidate11 === void 0 ? void 0 : _this$state$candidate11.salutation) === 'Divers',
        onChange: this.setSalutation
      }), /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Vorname',
        id: 'firstname',
        value: (_this$state$candidate12 = this.state.candidateInfos) === null || _this$state$candidate12 === void 0 ? void 0 : _this$state$candidate12.firstname,
        onChange: this.setFirstName,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Nachname',
        id: 'lastname',
        value: (_this$state$candidate13 = this.state.candidateInfos) === null || _this$state$candidate13 === void 0 ? void 0 : _this$state$candidate13.lastname,
        onChange: this.setLastName,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Postleitzahl',
        id: 'zipcode',
        value: (_this$state$candidate14 = this.state.candidateInfos) === null || _this$state$candidate14 === void 0 ? void 0 : _this$state$candidate14.zipcode,
        onChange: this.setZipcode,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Stadt',
        id: 'city',
        value: (_this$state$candidate15 = this.state.candidateInfos) === null || _this$state$candidate15 === void 0 ? void 0 : _this$state$candidate15.city,
        onChange: this.setCity,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'E-Mail',
        id: 'email',
        value: (_this$state$candidate16 = this.state.candidateInfos) === null || _this$state$candidate16 === void 0 ? void 0 : _this$state$candidate16.email,
        disabled: !this.props.forceEditMode,
        onChange: this.setEmail,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Telefon',
        id: 'phone',
        value: (_this$state$candidate17 = this.state.candidateInfos) === null || _this$state$candidate17 === void 0 ? void 0 : _this$state$candidate17.phone,
        onChange: this.setPhoneNumber,
        fullWidth: true
      }), this.props.candidateType && this.props.candidateType !== 'apprentice' && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].formTitle
      }, "Familienstand"), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Ledig',
        id: 'familysituation',
        value: 'ledig',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate18 = this.state.candidateInfos) === null || _this$state$candidate18 === void 0 ? void 0 : _this$state$candidate18.familysituation) === 'ledig',
        onChange: this.setFamilySituation
      }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Verheiratet',
        id: 'familysituation',
        value: 'verheiratet',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate19 = this.state.candidateInfos) === null || _this$state$candidate19 === void 0 ? void 0 : _this$state$candidate19.familysituation) === 'verheiratet',
        onChange: this.setFamilySituation
      }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Eingetragene Partnerschaft',
        id: 'familysituation',
        value: 'partner',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate20 = this.state.candidateInfos) === null || _this$state$candidate20 === void 0 ? void 0 : _this$state$candidate20.familysituation) === 'partner',
        onChange: this.setFamilySituation
      }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Geschieden',
        id: 'familysituation',
        value: 'geschieden',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate21 = this.state.candidateInfos) === null || _this$state$candidate21 === void 0 ? void 0 : _this$state$candidate21.familysituation) === 'geschieden',
        onChange: this.setFamilySituation
      }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Verwitwet',
        id: 'familysituation',
        value: 'verwitwet',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate22 = this.state.candidateInfos) === null || _this$state$candidate22 === void 0 ? void 0 : _this$state$candidate22.familysituation) === 'verwitwet',
        onChange: this.setFamilySituation
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ERGOComponents["default"].formTitle
      }, "Branchenkenner"), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Branchenfremd',
        id: 'branche',
        value: 'fremd',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate23 = this.state.candidateInfos) === null || _this$state$candidate23 === void 0 ? void 0 : _this$state$candidate23.branche) === 'fremd',
        onChange: this.setBranche
      }), /*#__PURE__*/_react["default"].createElement(_core.FormControlLabel, {
        label: 'Branchenkenner',
        id: 'branche',
        value: 'kenner',
        control: /*#__PURE__*/_react["default"].createElement(StyledRadio, {
          color: 'default'
        }),
        checked: ((_this$state$candidate24 = this.state.candidateInfos) === null || _this$state$candidate24 === void 0 ? void 0 : _this$state$candidate24.branche) === 'kenner',
        onChange: this.setBranche
      })), this.props.isSingleUser && !this.props.forceEditMode ? null : /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Kommentar',
        id: 'comment',
        value: this.state.candidateInfos.comment,
        onChange: this.setComment,
        fullWidth: true,
        multiline: true,
        rows: 3
      }), !this.props.forceEditMode && /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Angelegt',
        id: 'created',
        value: "".concat(createdDateToShow.dateString, " - ").concat(createdDateToShow.timeString),
        disabled: true,
        fullWidth: true
      }), !this.props.forceEditMode && /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        label: 'Aktualisiert',
        id: 'updated',
        value: "".concat(updatedDateToShow.dateString, " - ").concat(updatedDateToShow.timeString),
        disabled: true,
        fullWidth: true
      }), this.props.forceEditMode ? /*#__PURE__*/_react["default"].createElement(StyledButton, {
        className: _ERGOComponents["default"].saveButton,
        onClick: this.createCandidate
      }, "Interessent anlegen") : /*#__PURE__*/_react["default"].createElement(StyledButton, {
        className: _ERGOComponents["default"].saveButton,
        onClick: this.saveUserData
      }, "\xC4nderungen speichern")));
    }
  }]);
  return ErgoCandidateView;
}(_react["default"].Component);

exports["default"] = ErgoCandidateView;
ErgoCandidateView.propTypes = {
  infos: _propTypes["default"].object,
  triggerCandidateReload: _propTypes["default"].func,
  isSingleUser: _propTypes["default"].bool,
  forceEditMode: _propTypes["default"].bool,
  candidateType: _propTypes["default"].string,
  info: _propTypes["default"].string
};
ErgoCandidateView.defaultProps = {
  isSingleUser: false,
  forceEditMode: false
};